import React from 'react';
import { PAYMENT_METHODS } from 'Features/PaymentMethodSelector/PaymentMethodSelector';
const imgUrl = {
  'direct credit card': '/account/static/images/cards/credit-card-icon.png',
  paypal: '/account/static/images/cards/PayPal@3x.png',
  'apple pay': '/account/static/images/cards/ApplePay@2x.png',
};

const customClass = {
  'direct credit card': 'creditCardButton',
  paypal: 'paypalButton',
  'apple pay': 'applePayButton',
};

export const PaymentTypeButton = ({ button, checkHighlight, highlightSelection }) => {
  const url = imgUrl[button];
  const handleClick = () => {
    return highlightSelection(button);
  };

  return (
    <div className={`paymentTypeButton ${customClass[button]} ${checkHighlight(button)}`} onClick={() => handleClick()}>
      <img className="paymentSelectorImage" src={url} alt={`${button} logo image`} />
      {button === PAYMENT_METHODS.CARD && <p>&nbsp;Credit Card</p>}
    </div>
  );
};
